import { Table, Header, SpaceBetween } from "@amzn/awsui-components-react";
import { COLUMN_DEFINITIONS } from "./executionsTableConfig";
import { RedriveRequestItem } from "../../../types/common";

interface ExecutionsTableProps {
  items: RedriveRequestItem[];
  loading: boolean;
}

export function ExecutionsTable({
  items,
  loading = false,
}: ExecutionsTableProps) {
  return (
    <Table
      resizableColumns
      stickyHeader
      columnDefinitions={COLUMN_DEFINITIONS}
      items={items}
      loading={loading}
      loadingText="Loading resources"
      selectionType="multi"
      header={
        <Header
          variant="awsui-h1-sticky"
          counter={items.length > 0 ? `(${items.length})` : undefined}
        >
          Past Order Redrives
        </Header>
      }
      empty={
        <SpaceBetween size="m" alignItems="center">
          <div>No executions found</div>
        </SpaceBetween>
      }
    />
  );
}
